import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import { ADGMImage } from 'aurora-components';

import styles from './styles';
import { keyEmptyCheck } from '../../utils/utils';

function NoPropertySelection(props) {
  const { classes, isSelectedPMAProperties } = props;

  return (
    <div className={classes.NoPropertySelection}>
      <figure>
        <ADGMImage name='emptystate1.png' alt='empty-state' />
      </figure>
      <div className={classes.prTextHolder}>
        <Typography variant='body1' component='h1' className={classes.prTitle}>
          {keyEmptyCheck(isSelectedPMAProperties ? 'pma_more_properties' : 'pma_bank_title')}
        </Typography>
        <Typography variant='body1'>{keyEmptyCheck('pma_bank_search_subTitle')}</Typography>
      </div>
    </div>
  );
}

NoPropertySelection.propTypes = {
  classes: PropTypes.object.isRequired,
  isSelectedPMAProperties: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoPropertySelection);
